import { render } from "./MatrixPublishingTask.vue?vue&type=template&id=7ce47052&scoped=true"
import script from "./MatrixPublishingTask.vue?vue&type=script&lang=js"
export * from "./MatrixPublishingTask.vue?vue&type=script&lang=js"

import "./MatrixPublishingTask.vue?vue&type=style&index=0&id=7ce47052&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce47052"]])

export default __exports__